// extracted by mini-css-extract-plugin
export default {"tooltip":"sO-z","arrow":"tO-z"};